import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5457_9788)">
      <path
        d="M12 24.7581C18.6274 24.7581 24 19.3855 24 12.7581C24 6.13064 18.6274 0.758057 12 0.758057C5.37258 0.758057 0 6.13064 0 12.7581C0 19.3855 5.37258 24.7581 12 24.7581Z"
        fill="#00EF8B"
      />
      <path
        d="M17.2787 10.8892H13.8853V14.2826H17.2787V10.8892Z"
        fill="white"
      />
      <path
        d="M10.4918 15.5449C10.4918 16.2498 9.91799 16.8236 9.21308 16.8236C8.50816 16.8236 7.93439 16.2498 7.93439 15.5449C7.93439 14.84 8.50816 14.2662 9.21308 14.2662H10.4918V10.8892H9.22947C6.6557 10.8892 4.57373 12.9711 4.57373 15.5449C4.57373 18.1187 6.6557 20.2006 9.22947 20.2006C11.8032 20.2006 13.8852 18.1187 13.8852 15.5449V14.2662H10.4918V15.5449Z"
        fill="white"
      />
      <path
        d="M15.1474 9.1843H18.9671V5.80725H15.1474C12.5737 5.80725 10.4917 7.88922 10.4917 10.463V10.8892H13.8851V10.463C13.8851 9.75807 14.4589 9.1843 15.1474 9.1843Z"
        fill="white"
      />
      <path
        d="M10.4917 14.2662H13.8851V10.8892H10.4917V14.2662Z"
        fill="#16FF99"
      />
    </g>
    <defs>
      <clipPath id="clip0_5457_9788">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.758057)"
        />
      </clipPath>
    </defs>
  </svg>
)
